export const ratePlansTab = {
  sectionLabel: {
    title: "Taryfy widoczne w rezerwacji bezpośredniej",
    hintHotel:
      "Wybierz, które taryfy pojawiają się przy każdym typie pokoju, ustal ich kolejność i taryfę domyślną.",
    hintApartment:
      "Wybierz, które taryfy widzi gość, przeciągnij, aby zmienić kolejność, i oznacz domyślną.",
  },
  loading: "Wczytywanie taryf…",
  empty: {
    apartment: "Brak taryf skonfigurowanych dla tego obiektu.",
    hotel: "Brak typów pokoi skonfigurowanych w tym hotelu.",
    room: "Brak taryf skonfigurowanych dla tego pokoju.",
  },
  derivedPill: "Pochodna",
  dragHandleTitle: "Przeciągnij, aby zmienić kolejność",
  visibleSwitchTitle: "Pokaż w rezerwacji bezpośredniej",
  expandTitleClose: "Zamknij ustawienia",
  expandTitleOpen: "Ustaw nazwę, politykę i wartość domyślną",
  visibleNameLabel: "Nazwa wyświetlana",
  visibleNamePlaceholderApartment: "Np. Bezzwrotna / Elastyczna",
  visibleNamePlaceholderHotel: "Np. Ze śniadaniem",
  cond: {
    refundable: "Można anulować",
    refundableHint: "Ty decydujesz, do kiedy jest bezpłatnie.",
    nonRefundable: "Bezzwrotna",
    nonRefundableHint: "Nic nie jest zwracane. Gość może anulować, ale zostanie obciążony 100%. Widzi to przed zapłatą.",
    freeDays: "Bezpłatne anulowanie do",
    freeDaysPlaceholder: "Bez limitu",
    freeDaysHelp: "Dni przed przyjazdem. Puste = bezpłatnie aż do przyjazdu.",
    penalty: "Później pobierasz",
    penaltyHelp: "Od całości pobytu. 100% = nic nie jest zwracane.",
    sinGuardar: "Ta stawka nie ma jeszcze zapisanych warunków. Poniżej jest propozycja — naciśnij „Zapisz zasady”, aby ją zastosować.",
    aplicarTodas: "Zastosuj do wszystkich pokoi",
    aplicarTodasHelp: "Ten sam warunek zostanie ustawiony w stawce „{name}” jeszcze 1 pokoju. | Ten sam warunek zostanie ustawiony w stawce „{name}” jeszcze {count} pokoi.",
    notes: "Uwagi dla gościa (opcjonalnie)",
    previewNonRefundable: "Gość przeczyta: „Ta taryfa jest bezzwrotna: rezerwacji nie można anulować”.",
    previewFree: "Gość przeczyta: „Bezpłatne anulowanie do przyjazdu”.",
    previewDayPenalty: "Gość przeczyta: „Bezpłatne anulowanie do dnia przyjazdu; później pobierane jest {pct}%”.",
    previewUntilPenalty: "Gość przeczyta: „Bezpłatnie do 1 dnia przed; później pobierane jest {pct}%”. | Gość przeczyta: „Bezpłatnie do {count} dni przed; później pobierane jest {pct}%”.",
    shortNonRefundable: "Bezzwrotna",
    shortFree: "Bezpłatne anulowanie",
    shortDayPenalty: "Bezpłatnie do przyjazdu · potem {pct}%",
    shortUntilPenalty: "Bezpłatnie do 1 dnia przed · potem {pct}% | Bezpłatnie do {count} dni przed · potem {pct}%",
  },
  cancellationPolicyLabel: "Polityka anulowania",
  policyEmpty: "Brak ustawionej polityki",
  policyEdit: "Edytuj",
  policyAdd: "Dodaj",
  defaultLabel: "Domyślna",
  rulesApartment: "Zasady: co najmniej 1 widoczna i 1 domyślna (która musi być widoczna).",
  rulesRoom: "Każdy pokój musi mieć co najmniej 1 widoczną taryfę i 1 domyślną.",
  tip: 'Wskazówka: ustaw taryfę „Elastyczna” jako domyślną, a pozostałe pokaż jako „Bezzwrotne”.',
  room: {
    ratePlansCount: "{count} taryfa | {count} taryfy | {count} taryf",
    includedGuestsTitle: "Ilu gości obejmuje cena (na potrzeby opłaty za dodatkową osobę)",
    includes: "Obejmuje",
    person: "gość | goście | gości",
    meta: "Pojemność: {capacity} • Dorośli: {adults} • Dzieci: {children}",
  },
  modal: {
    eyebrow: "Polityka anulowania",
    closeAria: "Zamknij",
    hint: "Ten tekst zobaczy gość w rezerwacji bezpośredniej. Proszę opisać warunki anulowania dla tej taryfy.",
    textareaPlaceholder:
      "Np. Bezpłatne anulowanie do 48 h przed check-in. Później pobierana jest opłata za pierwszą noc. Bezzwrotna w sezonie wysokim.",
    clear: "Wyczyść",
    cancel: "Anuluj",
    saving: "Zapisywanie…",
    save: "Zapisz politykę",
    defaultTitle: "Taryfa",
  },
  toasts: {
    loadError: "Nie udało się wczytać taryf.",
    saveSuccess: "Taryfy zapisane pomyślnie.",
    saveError: "Nie udało się zapisać taryf.",
  },
  validation: {
    roomMinVisible: 'Pokój „{name}” musi mieć co najmniej 1 widoczną taryfę.',
    roomOneDefault: 'Pokój „{name}” musi mieć dokładnie 1 taryfę domyślną.',
    roomDefaultVisible: 'W pokoju „{name}” taryfa domyślna musi być widoczna.',
    minVisible: "Musi pozostać co najmniej 1 widoczna taryfa.",
    oneDefault: "Musi być dokładnie 1 taryfa domyślna.",
    defaultVisible: "Taryfa domyślna musi być widoczna.",
  },
};
